import { BufferGeometry, Group, LineBasicMaterial, LineSegments, Mesh, Vector3, WireframeGeometry } from "three";
import { createBboxMesh, getGroupSize } from "./createBboxMesh";
import { WIREFRAME_THRESHOLD } from "../../../../constants";

export const createWireframe = (group: Group) => {
    const wireframes: LineSegments<WireframeGeometry<BufferGeometry>, LineBasicMaterial>[] = [];
    const material = new LineBasicMaterial({ depthTest: false, opacity: 0.25, transparent: true });
    const size = getGroupSize(group).size;

    group.traverse((obj) => {
        if ((obj as Mesh).isMesh) {
            const mesh = obj as Mesh;
            const simplified = mesh.clone();
            let wireframe: WireframeGeometry<BufferGeometry>;

            if (simplified.geometry.attributes.position.count > WIREFRAME_THRESHOLD) {
                const box = createBboxMesh(simplified);

                wireframe = new WireframeGeometry(box.geometry);
                wireframe.translate(0, size.y / 2, 0);
            } else {
                wireframe = new WireframeGeometry(mesh.geometry);
            }
            const line = new LineSegments(wireframe, material);
            line.applyMatrix4(mesh.matrixWorld);

            line.position.copy(mesh.position);
            line.rotation.copy(mesh.rotation);
            wireframes.push(line);
        }
    });
    const wireframesGroup = new Group();
    wireframes.map((wireframe) => wireframesGroup.attach(wireframe));
    wireframesGroup.name = "wireframesGroup";
    return wireframesGroup;
};
